"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waterMeterTypeOptions = exports.statusOptions = exports.sourceTypeOptions = exports.serviceTypeOptions = exports.serviceCategoryOptions = exports.rowsPerPageOptions = exports.resourceOptionsList = exports.MONTH_OPTIONS = exports.meterTypeOptions = exports.inHouseResourceOptions = exports.columns = exports.chargeColumns = void 0;
var columns = [
    { name: "NAME", uid: "name" },
    { name: "TYPE", uid: "serviceType" },
    { name: "BUILDING", uid: "buildingName" },
    { name: "LEVEL", uid: "level" },
    { name: "STATUS", uid: "status" },
    { name: "ACTIONS", uid: "actions" },
];
exports.columns = columns;
var chargeColumns = [
    { name: "CHARGE NAME", uid: "chargeName" },
    { name: "TYPE", uid: "chargeType" },
    { name: "UNIT MEASURE", uid: "unitMeasure" },
    { name: "RATE MODE", uid: "rateMode" },
    { name: "RATE / TIERS", uid: "rate" },
    { name: "PARTY", uid: "partyType" },
    { name: "STATUS", uid: "status" },
    { name: "ACTIONS", uid: "actions" },
];
exports.chargeColumns = chargeColumns;
var serviceTypeOptions = [
    { key: "all", label: "All Types" },
    { key: "POWER", label: "Power" },
    { key: "WATER", label: "Water" },
    { key: "SEWERAGE", label: "Sewerage" },
    { key: "REFUSE", label: "Refuse" }, // SGF-1
    { key: "INTERNET_FIXED_LINE", label: "Internet and Fixed Line" }, // SGF-1
    { key: "BACKUP_GENERATOR_POWER", label: "Back-Up Generator Power" }, // SGF-1
];
exports.serviceTypeOptions = serviceTypeOptions;
// SGF-1: month dropdown options (value = 1-12 as string).
var MONTH_OPTIONS = [
    { key: "1", label: "January" },
    { key: "2", label: "February" },
    { key: "3", label: "March" },
    { key: "4", label: "April" },
    { key: "5", label: "May" },
    { key: "6", label: "June" },
    { key: "7", label: "July" },
    { key: "8", label: "August" },
    { key: "9", label: "September" },
    { key: "10", label: "October" },
    { key: "11", label: "November" },
    { key: "12", label: "December" },
];
exports.MONTH_OPTIONS = MONTH_OPTIONS;
var serviceCategoryOptions = [
    { key: "BULK", label: "Bulk" },
    { key: "ADDITIONAL", label: "Additional" },
];
exports.serviceCategoryOptions = serviceCategoryOptions;
var sourceTypeOptions = [
    { key: "BUILDING", label: "Building" },
    { key: "RESOURCE", label: "Resource" },
];
exports.sourceTypeOptions = sourceTypeOptions;
var resourceOptionsList = [
    { key: "SOLAR", label: "Solar" },
    { key: "GENERATOR", label: "Generator" },
    { key: "DIESEL", label: "Diesel" },
    { key: "GAS", label: "Gas" },
    { key: "BOREHOLE", label: "Borehole" },
    { key: "BESS", label: "BESS" },
];
exports.resourceOptionsList = resourceOptionsList;
var inHouseResourceOptions = [
    { key: "GENERATOR", label: "Generator" },
    { key: "SOLAR", label: "Solar" },
    { key: "BOREHOLE", label: "Borehole" },
    { key: "GAS", label: "Gas Power Plant" },
    { key: "BESS", label: "BESS" },
];
exports.inHouseResourceOptions = inHouseResourceOptions;
var meterTypeOptions = [
    { key: "DIRECT", label: "Direct" },
    { key: "CURRENT_TRANSFORMER", label: "Current Transformer" },
];
exports.meterTypeOptions = meterTypeOptions;
var waterMeterTypeOptions = [
    { key: "MECHANICAL", label: "Mechanical" },
    { key: "ULTRASONIC", label: "Ultrasonic" },
    { key: "ELECTROMAGNETIC", label: "Electromagnetic" },
];
exports.waterMeterTypeOptions = waterMeterTypeOptions;
var statusOptions = [
    { key: "all", label: "All" },
    { key: "Active", label: "Active" },
    { key: "Inactive", label: "Inactive" },
];
exports.statusOptions = statusOptions;
var rowsPerPageOptions = [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
